var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadgoldcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4762_9863)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25947 17.0091H9.7409C14.1609 17.0091 17.75 13.42 17.75 8.99995C17.75 4.57993 14.1609 0.990845 9.7409 0.990845",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9389 15.0683L13.51 15.0872L14.4823 14.0704L15.957 14.0475L14.9389 15.0697V15.0683Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4824 15.4536L13.0037 15.4711L12.1808 15.9829L13.8845 15.8536L14.4824 15.4536Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0049 5.62494L15.4682 5.53606C15.3107 5.16301 14.7343 4.30109 14.3114 3.82434L15.9571 3.95363C16.3046 4.41287 16.7692 5.16166 17.0049 5.62494Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25896 17.0091C3.83566 17.0091 0.249857 13.4233 0.249857 8.99995C0.249857 4.57664 3.83566 0.990845 8.25896 0.990845C12.6823 0.990845 16.2681 4.57664 16.2681 8.99995C16.2681 13.4233 12.6823 17.0091 8.25896 17.0091Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25896 17.0091C3.83566 17.0091 0.249857 13.4233 0.249857 8.99995C0.249857 4.57664 3.83566 0.990845 8.25896 0.990845C12.6823 0.990845 16.2681 4.57664 16.2681 8.99995C16.2681 13.4233 12.6823 17.0091 8.25896 17.0091Z",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10425 8.99996C2.33723 2.6285 8.28985 2.31067 8.20366 2.31067C4.51088 2.31067 1.51437 5.30853 1.51437 8.99996C1.51437 12.6914 4.51223 15.6893 8.20366 15.6893C8.28985 15.6893 2.21468 15.327 2.10425 8.99996Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25891 15.7444C4.53402 15.7444 1.5144 12.7248 1.5144 8.99988C1.5144 5.27499 4.53402 2.25537 8.25891 2.25537C11.9838 2.25537 15.0034 5.27499 15.0034 8.99988C15.0034 12.7248 11.9838 15.7444 8.25891 15.7444Z",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25947 17.0091H9.7409C14.1609 17.0091 17.75 13.42 17.75 8.99995C17.75 4.57993 14.1609 0.990845 9.7409 0.990845",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74072 0.990845H8.2593",
    stroke: "#0B1420",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09288 7.05393C5.09288 8.38047 5.94671 9.45652 7.00122 9.45652C7.53722 9.45652 8.02205 9.17775 8.36816 8.72928C8.03282 8.29832 7.82677 7.7071 7.82677 7.05393C7.82677 6.65933 7.90219 6.28628 8.03686 5.95902C8.03686 5.95902 6.82479 5.31393 5.20061 6.25665C5.13058 6.5058 5.09288 6.7738 5.09288 7.05393Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20061 6.25657C6.82479 5.31384 8.03686 5.95894 8.03686 5.95894C8.12306 5.7448 8.23484 5.54818 8.36816 5.37849C8.02205 4.93002 7.53722 4.65125 7.00122 4.65125C6.16893 4.65125 5.46054 5.32193 5.20061 6.25657Z",
    fill: "#ECD559",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50684 8.89495C8.32233 8.70775 7.93716 8.35356 7.45503 8.28218C6.89074 8.19868 6.37763 8.38049 6.21602 8.82223C6.00593 9.39863 6.46382 10.0868 7.17356 10.27C7.5062 10.3562 7.90349 10.3414 8.24018 10.1851",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50684 8.89495C8.32233 8.70775 7.93716 8.35356 7.45503 8.28218C6.89074 8.19868 6.37763 8.38049 6.21602 8.82223C6.00593 9.39863 6.46382 10.0868 7.17356 10.27C7.5062 10.3562 7.90349 10.3414 8.24018 10.1851",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82687 7.05385C7.82687 7.70702 8.03293 8.29824 8.36827 8.7292C8.71438 9.17767 9.19921 9.45645 9.73521 9.45645C10.7897 9.45645 11.6436 8.3804 11.6436 7.05385C11.6436 6.97305 11.6409 6.89224 11.6341 6.81278C10.9998 6.35893 9.87124 5.72461 8.64704 5.83774C8.44503 5.85659 8.24167 5.89565 8.03697 5.95894C7.90229 6.2862 7.82687 6.65925 7.82687 7.05385Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03712 5.95906C8.24182 5.89576 8.44518 5.85671 8.64719 5.83785C9.87139 5.72472 11 6.35904 11.6343 6.8129C11.5387 5.59948 10.7252 4.65137 9.73536 4.65137C9.19936 4.65137 8.71453 4.93014 8.36842 5.37861C8.23509 5.5483 8.12331 5.74493 8.03712 5.95906Z",
    fill: "#ECD559",
    stroke: "black",
    strokeWidth: 0.196625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65976 6.13538C9.17494 6.13538 8.78034 6.63098 8.78034 7.2424C8.78034 7.85383 9.17359 8.34943 9.65976 8.34943C10.1177 8.34943 10.4638 7.86999 10.4961 7.58717L9.72171 7.23028L10.4826 6.85185C10.4193 6.5192 10.088 6.13538 9.65976 6.13672V6.13538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98935 5.95898C6.50452 5.95898 6.10993 6.45459 6.10993 7.06601C6.10993 7.67743 6.50318 8.17304 6.98935 8.17304C7.44725 8.17304 7.79336 7.69359 7.82568 7.41078L7.0513 7.05389L7.81222 6.67545C7.74892 6.34281 7.41762 5.95898 6.98935 5.96033V5.95898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71974 12.6441C5.97562 13.2502 6.97221 12.6037 7.79373 12.6441C8.89806 12.698 9.67918 13.3175 9.93506 12.7249C8.23816 11.8361 6.54126 12.3883 6.54126 12.3883C6.40658 12.2132 6.32578 11.9842 6.28537 11.7014C5.80055 11.9842 5.59853 12.3613 5.71974 12.6441Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.202012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28541 11.7015C6.32582 11.9843 6.40662 12.2132 6.5413 12.3883C6.5413 12.3883 8.2382 11.8361 9.9351 12.725C10.1371 12.2536 9.31559 11.3513 7.80724 11.3513C7.14733 11.3513 6.63557 11.4995 6.28541 11.7015Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.202012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68523 4.66073C6.37746 4.85197 7.16261 4.59204 7.53027 4.17725",
    stroke: "black",
    strokeWidth: 0.789194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.292 5.07954C10.5796 5.1765 9.83751 4.81288 9.5291 4.35229",
    stroke: "black",
    strokeWidth: 0.789194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4762_9863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadgoldcoin);
export default __webpack_public_path__ + "static/media/sadgoldcoin.8bd714fb384a75ed8632e1eea594c3c9.svg";
export { ForwardRef as ReactComponent };